import {
  PRISM_ENTER,
  PRISM_EXIT,
  SAVE_PRISM_IMAGES,
  SAVE_MAIN_PRISM_IMAGE,
  CLEAR_PRISM_IMAGES
} from 'actions/prism';

const DEFAULT_STATE = {
  entryPageUrl: undefined,
  mainImage: undefined,
  slideImages: []
};

export default function prism(state = DEFAULT_STATE, action) {
  const { type, entryPageUrl } = action;
  switch (type) {
    case PRISM_ENTER:
      return { ...state, entryPageUrl };
    case PRISM_EXIT:
      return { ...state, entryPageUrl: undefined };
    case SAVE_PRISM_IMAGES:
      return {
        ...state,
        slideImages: [state.mainImage].concat(action.payload.images)
      };
    case SAVE_MAIN_PRISM_IMAGE:
      return {
        ...state,
        mainImage: { id: action.payload.id },
        slideImages: [{ id: action.payload.id }]
      };
    case CLEAR_PRISM_IMAGES:
      return {
        ...state,
        mainImage: undefined,
        slideImages: []
      };
    default:
      return state;
  }
}
